import i18next from 'i18next';

export default function initI18n(): void {
  i18next.addResourceBundle('en', 'data-grid-ui', {
    clearSelection: 'Clear selection',
    selectRows: 'Select rows',
    searchFallbackActive: 'No exact matches — showing similar',
    addRow: 'Add row',
    downloadAsCsv: 'Download as CSV',
    customCsvExport: 'Custom CSV export...',
    expandToFullscreen: 'Expand to fullscreen',
    closeFullscreen: 'Close fullscreen',
    customCsvExportTitle: 'Custom CSV export',
    customCsvExportDescription:
      'Choose the columns to export. Headers will use field names; values will be unformatted (raw from the database).',
    nicknameRole: 'Nickname: {{nickName}}  Role: {{role}}',
    userUnpinned: 'User unpinned',
    userPinned: 'User pinned',
    restoreRefusedCount: '{{refused}} of {{total}} could not be restored',
  });
}
